import React from 'react';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { ApartmentFilter } from '../../../../models/Filter';
import { ApartmentButtonFilterView } from '../../apartments/ApartmentButtonFilterView';

interface IMobileApartments {
    filter: ApartmentFilter;
    handleChange: (filter: ApartmentFilter) => void;
    classNameGroup?: string;
}

export const MobileApartmentsButtonFilterView: React.FC<IMobileApartments> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    return (
        <MobileFilter2 filterTitle='Апартаменты'>
            <ApartmentButtonFilterView
                filter={filter}
                handleChange={handleChange}
                classNameGroup={classNameGroup}
            />
        </MobileFilter2>
    );
};
